import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { QUERY_KEYS } from "./queryKeys";

export function useDeployment(chatId?: string, deploymentId?: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.DEPLOYMENTS, deploymentId],
    queryFn: () => {
      if (!chatId) {
        throw new Error("chatId is required");
      }
      if (!deploymentId) {
        throw new Error("deploymentId is required");
      }
      return api.getDeployment(chatId, deploymentId);
    },
    enabled: !!chatId && !!deploymentId,
  });
}
